/*
 * @Author: your name
 * @Date: 2019-09-06 10:58:32
 * @LastEditTime: 2022-03-04 18:05:48
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \Codes\2019\CQ\cq-vs-vote\src\main.js
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store.js'

/* use Vant */
import Vant from 'vant'
import 'vant/lib/index.css'
Vue.use(Vant)

Vue.config.productionTip = false
Vue.prototype.$store = store
// Vue.prototype.$router = router

/* import public js */
import utils from './utils/utils.js'
Vue.prototype.$utils = utils
utils.getUrlParams()
utils.getRemSize()

/* import customized ui */
import './assets/css/reset-mobile.css'
import './assets/css/option.css'
import './assets/css/tpl.css'

/* 封装过的axios */
import { get, post, put, deletes } from './axios/axios'
import apis from './axios/apis'

import { Toast } from 'vant'
Vue.prototype.$toast = Toast

Vue.prototype.$get = get
Vue.prototype.$post = post
Vue.prototype.$put = put
Vue.prototype.$delete = deletes
Vue.prototype.$apis = apis

/*  */
import config from './config'
Vue.prototype.$config = config

// * 加密接口
import { fetchApi } from "cq-decrypt"
Vue.prototype.$fetchApi = fetchApi;

// * 参数签名
import { urlKeyValue } from "@/utils/md5-sign.js";
Vue.prototype.$urlKeyValue = urlKeyValue;

/* js BRIDGE */
import { WebBridgeApi } from "ijsbridge";
Vue.prototype.$webBridgeApi = WebBridgeApi

// import lottie from 'vue-lottie';
// Vue.component('lottie', lottie)

// import xss from 'xss';
// Vue.prototype.xss = xss

new Vue({
  // wxjssdkPlugin,
  router,
  store,
  render: h => h(App)
}).$mount('#app')

